const bioSortingData = {
  quan: {
    sort: 'DAT.PAUREUS',
    order: 'desc',
  },
  qual: {
    sort: 'DAT.ED',
    order: 'desc',
  },
};

export default bioSortingData;
